import { BorderRadius, Color, Flex, getShadow, Space, Spacing, Text } from '@billy/design-system'
import styled from '@emotion/styled'
import React, { ReactNode } from 'react'

interface ListSectionWrapperProps {
  borderColor?: string
}

const ListSectionWrapper = styled.div<ListSectionWrapperProps>`
  border-radius: ${BorderRadius.R12};
  border: ${({ borderColor }) => `1px solid ${borderColor || Color.Grey200}`};
  padding: ${Spacing.S16};
  background-color: ${Color.White};
  ${getShadow('raisedLight')};
`

const HeaderActions = styled.aside`
  margin-left: auto;
`

export type ListSectionProps = {
  borderColor?: string
  children: ReactNode
  className?: string
  headerActions?: ReactNode
  title: string
}

export const ListSection = ({ children, className, headerActions, title, ...rest }: ListSectionProps) => (
  <ListSectionWrapper {...rest}>
    <Flex as="header" alignItems="center">
      <Text weight="medium">{title}</Text>
      {headerActions && <HeaderActions>{headerActions}</HeaderActions>}
    </Flex>
    <Space size="s32" />
    {children}
  </ListSectionWrapper>
)
